import gql from 'graphql-tag';

export default gql`
  query countries {
    countries {
      name
      code
      states {
        name
        code
      }
    }
  }
`;
